// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"375":"5d5e5618","647":"2793b050"}[chunkId] + ".chunk.css";
};